import { render, staticRenderFns } from "./management.vue?vue&type=template&id=008b1d2c&scoped=true&"
import script from "./management.vue?vue&type=script&lang=js&"
export * from "./management.vue?vue&type=script&lang=js&"
import style0 from "./management.vue?vue&type=style&index=0&id=008b1d2c&prod&scoped=true&lang=scss&"
import style1 from "./management.vue?vue&type=style&index=1&id=008b1d2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b1d2c",
  null
  
)

export default component.exports